module.exports = __webpack_public_path__ + "static/media/Real Life.9f94fddd.jpg";